import React, {useContext, useEffect} from 'react';
import LazyBody from '@views/knowledge/components/LazyBody';
import DefaultLayout from '@src/components/_layouts/Default/DefaultLayout';
import {LayoutContext} from '@src/contexts/LayoutContext';
import app from '@src/helpers/app';
import {useDispatch} from 'react-redux';
import {articlesSetActiveId} from '@src/_redux/articles';

function Body() {
    const dispatch = useDispatch();
    const {setPageBreadcrumbItems} = useContext(LayoutContext);

    useEffect(() => void dispatch(articlesSetActiveId('create')), [dispatch]);

    useEffect(() => {
        setPageBreadcrumbItems([
            {
                uri: app('client-router').getRouteByName('knowledge@index')?.resolveUrl() ?? '#index',
                label: 'Articles.index-page-title',
            },
            {
                uri: '',
                isInteractive: false,
                label: 'Articles.create-page-title',
            }
        ]);

        return () => setPageBreadcrumbItems([]);
    }, [setPageBreadcrumbItems]);

    return <LazyBody pageTitle="Articles.create-page-title"/>;
}

export default function CreatePage() {
    return <DefaultLayout>
        <Body/>
    </DefaultLayout>;
}
